import type { FaireProductEntity } from "../../entity_types/product";

export const p_2q3tb6fmej: FaireProductEntity = {
  token: "p_2q3tb6fmej",
  type: "product",
  name: "18K Gold Paperclip Chain Necklace",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/7fd6d62162272dba8aeac53b584262306bb640b47b9b9953b1900ce1215ef70d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0cc2aa42cbface3bdccb5d3fa897ef6932b347f54830fa2c3f468d7010eee166.jpeg",
    "https://cdn.faire.com/fastly/39ae7cc0cc52ba391470063bd4c3e4945863ba2ade4356a9c68e1d073984e563.jpeg",
    "https://cdn.faire.com/fastly/aace84aa2ece6ee7302ac657039032a8ef8da46e8349a011e830e786f92b0435.jpeg",
    "https://cdn.faire.com/fastly/847dac493c123b8039172c1b7ebf2625c01d768d0ddaba67b78cd8c9453daa12.jpeg",
    "https://cdn.faire.com/fastly/fa3a91f6db8b95925901731df4747916112388532593dfae81dbee17662f6384.jpeg",
    "https://cdn.faire.com/fastly/25f0bbe96a1229ce82ec39737c20d66f864eaefd68e01ecc2f09d67abed6f79c.jpeg",
    "https://cdn.faire.com/fastly/f8ff645b0b504cf6d194011052d0a72699855b656381686f6beee9049e5bfe83.jpeg",
    "https://cdn.faire.com/fastly/270d2ea5737255cadb3af61afec4206b5a0df871ddb1b5f3406b666114e8a47f.jpeg",
    "https://cdn.faire.com/fastly/45361a327864184ae6287a87dca80767c8c23a6c13fb69fffb403974a79afc21.jpeg",
    "https://cdn.faire.com/fastly/fabca5a6c496b24a58d739e74b2dc99ccf3ee0735f25617dd6e887fa2adfbdf8.jpeg",
    "https://cdn.faire.com/fastly/a2df0b426f9ea8c365780b95df5458237402ae27d1d01b20109e3a85fa857cb3.jpeg",
    "https://cdn.faire.com/fastly/20393ded91c2225b5eda56729dde593b723baba6ba49bf537b09a298acc9fb99.jpeg",
    "https://cdn.faire.com/fastly/fddde41d2fbfa454a0f7ac3b0b50206a2473740530db16a7d30a8c017554a15c.jpeg",
    "https://cdn.faire.com/fastly/2173a6024ea549ce4ad2d98e934921d3345626d479685ea2faf6a4e5fb1996f8.jpeg",
    "https://cdn.faire.com/fastly/56bd38d10673db6f32f406cd2f61c43bf522e6a268c358b64f1e3eca5ce26999.jpeg",
    "https://cdn.faire.com/fastly/5a5c4da30a7028c81e36add549a3e9c6ce70905eb88c518485b95f9e90c64e89.jpeg",
    "https://cdn.faire.com/fastly/06e4d4d4795cec7f1550b17e0d02702e93ccb84d289a7bba76e06e2f4ede9a26.jpeg",
  ],
  priceDollars: 4.37,
  description:
    "High Demand!\n\nLooking for a minimal yet eye-catching necklace to compliment your customer's everyday style? The 18K Gold PVD stainless steel paperclip chain necklace is a modern, yet minimalist necklace for women that features a new trending chain design using dainty, paper-clip styled links.\n\nIt's a simple, casual necklace that can be worn anywhere and with anything, but the best part? You can add your favorite small pendants to add your own personalized touch or even layer it with other gold chains to create a unique layered necklace look. So don't miss out - grab yours today!\n\n• 100% Waterproof, Non-Tarnish, Hypoallergenic\n\nWe use the process of PVD Coating our 18K Gold chains over surgical grade 316L stainless steel for a non-tarnish, hypoallergenic finish that will hold up best to everyday wear and will never turn skin green. PVD coated jewelry is more resistant to corrosion and signs of wear than gold plated and gold filled jewelry, making it ideal for daily wear.",
  tags: [],
  msrpDollars: 30.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:15.053Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
